import { CrudEntity, CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';
import { isValueEmpty } from '@awp/helpers/utilsReact';

export const INIT_PRECEDENCE = {
  ObservationTypeId: null,
  Relative_Precedence_Number: 0.5,
  SensorTypeId: null,
  ModelSpecificationId: null,
};

export default class SensorTypeService extends CrudService {
  constructor(mode: string) {
    const entityName = 'Sensor Type';
    const entityPluralName = 'Sensor Types';

    super({ entityName, entityPluralName, mode });
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: any): any {
    /* Do Nothing */
  }

  mapInitialValues(props: any): any {
    const { entity, ...rest } = props;

    return {
      name: entity.Name ?? '',
      displayName: entity.DisplayName ?? '',
      description: entity.Description ?? '',
      sensorPlacementMetadata: entity.PlacementAttributeSchema ?? '',
      Precedences: isValueEmpty(entity.Precedences) ? [INIT_PRECEDENCE] : entity.Precedences,
    };
  }

  cleanFormValues(props: EntityProps): any {
    /* Do Nothing */
  }
}
